import { TranslationDict } from "../types";

export const frCommon: TranslationDict = {
  areYouSure: "Etes-vous sur ?",
  cancel: "Annuler",
  datum: "Date",
  deleteProject: "Supprimer le projet",
  error: "Erreur",
  filter: "Filtrer...",
  naam: "Nom",
  noProjectsFound: "Aucun projet trouvé",
  ok: "OK",
  openProject: "Ouvrir le projet",
  projectDeleteConfirm: "Ce projet sera supprimé définitivement.",
  projects: "Projets",
  projectName: "Nom du projet",
  save: "Enregistrer",
  saveProject: "Enregistrer le projet",
  sortByDate: "Trier par date",
  voornaam: "Prénom",
  firma: "Entreprise",
  straat: "Rue",
  huisnummer: "Numéro",
  postcode: "Code postal",
  plaats: "Ville",
  land: "Pays",
  telefoon: "Téléphone",
  btwnr: "Numéro de TVA",
  verwijderen: "Supprimer",
  hernoem: "Renommer",
  dupliceren: "Dupliquer",
  wijzigIcon: "Changer l'icône",
  wijzigNaam: "Changer le nom",
  wit: "Blanc",
  zwart: "Noir",
};
